import { Link } from 'react-router-dom';
import '../LandingPage.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <span className="footer-logo">
            EF<span>Soft</span>
          </span>
          <p className="footer-tagline">
            Expert software development solutions. Building robust web
            applications tailored to your needs.
          </p>
        </div>

        <div className="footer-nav">
          <div className="footer-col">
            <h4>Company</h4>
            <Link to="/">Home</Link>
            <a href="/#about">About</a>
            <a href="/#services">Services</a>
            <Link to="/products">Products</Link>
          </div>
          <div className="footer-col">
            <h4>Legal</h4>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/data-deletion">Data Deletion</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
          </div>
          <div className="footer-col">
            <h4>Contact</h4>
            <a href="tel:+447935501848">+44 7935 501 848</a>
            <a href="mailto:emil.filip@efsoft.co.uk">emil.filip@efsoft.co.uk</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} EFSoft. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
